import React, { useEffect, useMemo } from 'react';
import { Navigate, Route, Routes, useLocation } from 'react-router-dom';
import { MenuBar } from 'fragments';
import { useSelector } from 'react-redux';
import {
    AboutUs,
    ContactUs,
    Features,
    Home,
    LoginPage,
    PrivacyPolicy,
    TermsAndConditions,
    ClientInviteForm,
    SignatureRequest,
    DataCollection,
    Practice,
    AbaBillingSoftware,
    ManagedBilling,
    AbaScheduling,
    AbaBillingPlatform,
    AbaBillingPlatform2
} from '../pages';
import { InactivityHandler, loadGoogleMaps } from 'utils';
import { getToken, removeToken, removePermissions, removeUserInfo } from 'utils/crypto';

export const RouterSwitcher = () => {
    const accessToken = useSelector((state) => state.auth.accessToken);
    const location = useLocation();
    const search = typeof window !== 'undefined' ? window.location.search : '';
    const checkLinkReset = useMemo(() => search.includes('token=') || search.includes('resetToken='), [search]);
    const token = accessToken || (typeof window !== 'undefined' ? getToken() : null);
    const isSignatureRequest = location?.pathname === '/signature-request';
    const isPublicRoute = !token || checkLinkReset || isSignatureRequest;

    useEffect(() => {
        if (checkLinkReset) {
            removeToken();
            localStorage.removeItem('refresh-token');
            removePermissions();
            removeUserInfo();
            localStorage.removeItem('deviceId');
            sessionStorage.clear();
        }
    }, [checkLinkReset]);

    useEffect(() => {
        loadGoogleMaps()
            .then(() => {})
            .catch(() => console.error('Google Maps failed to load'));
    }, []);

    return (
        <>
            {isPublicRoute ? (
                <Routes>
                    <Route path='/' element={<Home />} />
                    <Route path='/qr/:id' element={<Home />} />
                    <Route path='/features' element={<Features />} />
                    <Route path='/about-us' element={<AboutUs />} />
                    <Route path='/contact-us' element={<ContactUs />} />
                    <Route path='/terms-and-conditions' element={<TermsAndConditions />} />
                    <Route path='/privacy-policy' element={<PrivacyPolicy />} />
                    <Route path='/login' element={<LoginPage />} />
                    <Route path='/forgot' element={<LoginPage />} />
                    <Route path='/resetPassword' element={<LoginPage />} />
                    <Route path='/resetPassword/:resetToken' element={<LoginPage />} />
                    <Route path='/register/:token' element={<LoginPage />} />
                    <Route path='/register' element={<LoginPage />} />
                    <Route path='/register-form' element={<ClientInviteForm />} />
                    <Route path='/signature-request' element={<SignatureRequest />} />
                    <Route path='/data-collection' element={<DataCollection />} />
                    <Route path='/practice' element={<Practice />} />
                    <Route path='/managed-billing' element={<ManagedBilling />} />
                    <Route path='/aba-billing-software' element={<AbaBillingSoftware />} />
                    <Route path='/aba-scheduling-software' element={<AbaScheduling />} />
                    <Route path='/aba-billing-platform' element={<AbaBillingPlatform />} />
                    <Route path='/aba-billing-platform-2' element={<AbaBillingPlatform2 />} />
                    <Route path="*" element={<Navigate to="/" replace />} />
                </Routes>
            ) : (
                <div className="open-sans">
                    <MenuBar />
                    <InactivityHandler />
                </div>
            )}
        </>
    );
};
